module.exports = __webpack_public_path__ + "img/Angiogenesis-OVCA_10X_OC.7412212e.png";